import queryString from 'query-string';

declare global {
  interface Window {
    ttq?: {
      instances: () => [{ pixelCode: string }],
    }
  }
}

interface Options {
  onChange: (data: {
    pixel_id?: string,
    click_id?: string,
  }) => void;
}

export function collectParams({ onChange }: Options): Promise<void> {
  return new Promise((resolve) => {
    const f = () => {
      const ttInstances = window.ttq && window.ttq.instances ? window.ttq.instances() : [];
      const pixel_id = ttInstances && ttInstances[0] ? ttInstances[0].pixelCode : undefined;
      const click_id = String(queryString.parse(window.location.search).ttclid || '') || undefined;

      if (pixel_id) {
        onChange({
          pixel_id: pixel_id,
          click_id: click_id,
        });
        resolve();
      } else {
        setTimeout(f, 50);
      }
    };
    f();
  });
}
